import React, { useEffect, useState } from "react";
import styled from "styled-components";
import EnjoyCoachLogo from "../../../images/coachEnjoyNoBgNoTitle.png";
import { useDispatch, useSelector } from "react-redux";
import { IS_HEAD } from "../../../permissions/roleTypes";
import FunctionalPage from "../../../pages/FunctionalPage";
import { NotFound } from "../../../pages/NotFoundPage";
import { getImage } from "../../../utils/utils";
import accountSVG from "../../../images/account.svg";
import GoHomeButton from "../../buttons/GoHomeButton";
import CoachEnjoyAnswer from "./CoachEnjoyAnswer";
import { CLEAR_ONE_AXIS } from "../../axis/actionTypes";
import {loadAllAxis} from "../../axis/all-axis/axisAction";

const EnjoyCoachStrategy = () => {
  const currentUser = useSelector((state) => state.currentUser);
  const dispatch = useDispatch();
  const [question, setQuestion] = useState("");
  const [adjust, setAdjust] = useState("");

  const close = () => {
    setQuestion("");
  };

  const handleClick = (item) => {
    if(question === item){
      setQuestion("")
    }
    else{
      setQuestion(item);
    }
  };

  const handleChange = (e) => {
    setAdjust(e.target.value);
  };
  useEffect(() => {
    dispatch(loadAllAxis())
    dispatch({ type: CLEAR_ONE_AXIS });
  }, [question, dispatch]);
  return (
    <>
      {IS_HEAD(currentUser.roles) && (
        <EnjoyCoachScreen>
          <div style={{ alignSelf: "flex-end", position: "absolute" }}>
            <GoHomeButton path={"/strategie"}/>
          </div>
          <Container>
            <EnjoyCoachBlock>
              <Card>
                <img src={EnjoyCoachLogo} alt="" />
                <p>COACH ENJOY</p>
              </Card>
              <DialArea style={{ minHeight: "70vh" }}>
                <CoachEnjoyAnswer
                  question={question}
                  setQuestion={setQuestion}
                  close={close}
                  adjust={adjust}
                />
              </DialArea>
            </EnjoyCoachBlock>
            <UserBlock>
              <Card>
                <img
                  style={{ borderRadius: "50%" }}
                  src={getImage(currentUser.photo, accountSVG)}
                  className={"current-picture"}
                  alt={"profil de l'utilisateur courant"}
                />
                <p>
                  {currentUser.firstName} {currentUser.lastName}
                </p>
              </Card>
              <QuestionBlock>
                <h3>Fenêtre de dialogue</h3>
                <textarea
                  onChange={handleChange}
                  value={adjust}
                  cols="30"
                  rows="5"
                ></textarea>
                <QuestionItem
                  className={
                    question === "strategicAxis" ? "question-selected" : ""
                  }
                  onClick={() => {
                    handleClick("strategicAxis");
                  }}
                >
                  {" "}
                  Aide-moi à chercher des axes stratégiques{" "}
                </QuestionItem>
                <QuestionItem
                  className={question === "SWOT" ? "question-selected" : ""}
                  onClick={() => {
                    handleClick("SWOT");
                  }}
                >
                  {" "}
                  Aide-moi à chercher des éléments du SWOT{" "}
                </QuestionItem>
                <QuestionItem
                  className={question === "stake" ? "question-selected" : ""}
                  onClick={() => {
                    handleClick("stake");
                  }}
                >
                  {" "}
                  Aide-moi à chercher des enjeux{" "}
                </QuestionItem>
                <QuestionItem
                  className={question === "project" ? "question-selected" : ""}
                  onClick={() => {
                    handleClick("project");
                  }}
                >
                  {" "}
                  Aide-moi à chercher des projets{" "}
                </QuestionItem>
                <QuestionItem
                    className={question === "improveAxis" ? "question-selected" : ""}
                    onClick={() => {
                      handleClick("improveAxis");
                    }}
                >
                  {" "}
                  Indique-moi ce que l'IA pourrait améliorer dans un axe{" "}
                </QuestionItem>
                <QuestionItem
                    className={question === "improveProject" ? "question-selected" : ""}
                    onClick={() => {
                      handleClick("improveProject");
                    }}
                >
                  {" "}
                  Indique-moi ce que l'IA pourrait améliorer dans un projet{" "}
                </QuestionItem>
                <QuestionItem
                    className={question === "VMVA" ? "question-selected" : ""}
                    onClick={() => {
                      handleClick("VMVA");
                    }}
                >
                  {" "}
                  Aide-moi pour des idées de valeurs, missions [...]{" "}
                </QuestionItem>
                <QuestionItem
                  className={
                    question === "axisAnalysis" ? "question-selected" : ""
                  }
                  onClick={() => {
                    handleClick("axisAnalysis");
                  }}
                >
                  {" "}
                  Fais-moi une analyse d'un axe comme un consultant{" "}
                </QuestionItem>
                <QuestionItem
                    className={
                      question === "projectAnalysis" ? "question-selected" : ""
                    }
                    onClick={() => {
                      handleClick("projectAnalysis");
                    }}
                >
                  {" "}
                  Fais-moi une analyse d'un projet comme un consultant{" "}
                </QuestionItem>
              </QuestionBlock>
            </UserBlock>
          </Container>
        </EnjoyCoachScreen>
      )}
      {!IS_HEAD(currentUser.roles) && (
        <FunctionalPage title={""} component={<NotFound />} />
      )}
    </>
  );
};
const EnjoyCoachScreen = styled.div`
  max-width: 95%;
  padding: 0.5rem;
  margin: auto;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1100px) {
    max-width: 90%;
  }

  @media screen and (min-width: 1600px) {
    max-width: 80%;
  }
`;
const Container = styled.div`
  padding: 1rem;
  display: grid;
  gap: 5%;
  height: 100%;
  grid-template-columns: 60% 35%;
`;
const EnjoyCoachBlock = styled.div`
  img {
    max-width: 80px;
  }
`;
const DialArea = styled.div`
  border: 2px solid var(--color-purple);
  border-radius: 15px;
  max-height: 90vh;
  overflow-y: scroll;
  
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  ::-webkit-scrollbar-thumb {
    width: 6px;
    border-radius: 10px;
    background-color: transparent;
  }
  :hover::-webkit-scrollbar-thumb{
    background-color: var(--color-purple);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  }
`;
const UserBlock = styled.div``;
const QuestionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  .question-selected {
      background: white;
      color: var(--color-purple) ;
      border: 2px solid var(--color-purple);
  }
  textarea {
    border: 2px solid var(--color-purple);
  }
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.5rem;
  img {
    width: 80px;
    height: 80px;
  }
  p {
    font-size: 18px;
    font-family: "Michroma", sans-serif;
  }
`;

const QuestionItem = styled.div`
  transition: 0.3s ease;
  padding: 0.6rem;
  border-radius: 5px;
  color: white;
  background: var(--color-purple-06);
  cursor: pointer;
  border: 2px solid transparent;
  font-size: calc(8px + (0.5vw));

  :hover {
    background: white;
    color: var(--color-purple);
    border: 2px solid var(--color-purple);
  }
`;

export default EnjoyCoachStrategy;
